import { render, staticRenderFns } from "./resourceadd.vue?vue&type=template&id=1250939c&"
import script from "./resourceadd.vue?vue&type=script&lang=js&"
export * from "./resourceadd.vue?vue&type=script&lang=js&"
import style0 from "./resourceadd.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1250939c')) {
      api.createRecord('1250939c', component.options)
    } else {
      api.reload('1250939c', component.options)
    }
    module.hot.accept("./resourceadd.vue?vue&type=template&id=1250939c&", function () {
      api.rerender('1250939c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/System/resource/resourceadd.vue"
export default component.exports